import React from 'react';

const TenantMemberFormModal = React.lazy(() => import('../components/FormModal'));
const tenantMemberModalRegistry = {
    core_tenantMemberId: TenantMemberFormModal
};
export default tenantMemberModalRegistry;
